module.exports = __webpack_public_path__ + "img/Ahmad-Rojib-Karimi.111f94da.png";